export enum RolesEnum {
  CLEARING_SUPER_ADMINISTRATOR = 'CLEARING_SUPER_ADMINISTRATOR',
  CLEARING_ADMINISTRATOR = 'CLEARING_ADMINISTRATOR',
  CLEARING_OPERATOR = 'CLEARING_OPERATOR',
  CLEARING_VIEWER = 'CLEARING_VIEWER',
  CLEARING_LIGHT = 'CLEARING_LIGHT'
}
